import { Project } from '../../project/Project';

export const migrateProject24To25 = (project: Project): Project => ({
  ...project,
  revision: project.revision ?? 'revisionIdGivenByMigration',
  reportRevision: project.reportRevision ?? ''
});
